import API from '../../../../../services/api';

export const NOTIFICACIONES_API = {
    get: async (tipo, page) => {
        return await API.get(`/notificaciones?tipo=${tipo}&page=${page}`).then(res => res.data);
    },
    getReminders: async () => {
        return await API.get('/recordatorios').then(res => res.data);
    },
    archiveById: async (notificacion, archived) => {
        return await API.put(`/notificaciones/${notificacion.id}`, {archivado: archived}).then(res => res.data);
    },
    archiveAll: async () => {
        return await API.post('/notificaciones/archivar', { type: 'all' }).then(res => res.data);
    }
}